module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"The valid BonusCode for the current account binding (Invalid after use):","noCodeTip":"No BonusCode"},"zn":{"title":"当前账号绑定的有效BonusCode（使用后失效）:","noCodeTip":"暂无BonusCode"}}')
  delete Component.options._Ctor
}
